import './ResetPassword.scss'
import { observer } from 'mobx-react'
import { authStore } from '../stores'
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { Background, Logo, Button, IonIcon, TextInput } from '../lib'
import bkg from '../assets/assess-bkg-04.png'

class ResetPassword extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      email: '',
    }
  }

  componentWillMount () {
    authStore.reset()
  }

  handleSubmit (e) {
    e.preventDefault()
    authStore.resetPassword(this.state.email)
  }

  handleChange (email) {
    this.setState({ email })
  }

  render () {
    if (authStore.auth) {
      return <Redirect to='/dashboard' />
    }
    return (
      <form className='ResetPassword' onSubmit={this.handleSubmit}>
        <p>Enter your email address below to receive a reset password link</p>
        <TextInput
          type='email'
          placeholder='Email'
          value={this.state.email}
          onChange={this.handleChange}
        />
        {authStore.error && (
          <p className='ResetPassword_error'>
            {authStore.error}
          </p>
        )}
        {authStore.sent ? (
          <p className='ResetPassword_success'>
            Email sent successfully!
          </p>
        ) : (
          <Button className='ResetPassword_action' type='submit'>
            Reset password
          </Button>
        )}
        <Button onClick={this.props.onBack} styleType="blank">
          <IonIcon icon="android-arrow-back" /> Go Back
        </Button>
      </form>
    )
  }
}

ResetPassword.displayName = 'ResetPassword'

export default observer(ResetPassword)



// WEBPACK FOOTER //
// ./src/auth/ResetPassword.js